module.exports = __webpack_public_path__ + "img/spending-analysis.15f0e71c.svg";